import React, { CSSProperties, FC } from 'react';
import { Text } from 'components/text/Text';
import { Card } from 'src/pages-all/user/user-profile/components/common';

export const SectionText: FC<{ style?: CSSProperties }> = ({ children, style = {} }) => (
  <Text size={30} fontWeight={500} style={style}>
    {children}
  </Text>
);

type SectionProps = {
  title: string;
  cardStyle?: CSSProperties & { [P: string]: any };
};

export const Section: FC<SectionProps> = ({ children, title, cardStyle = {} }) => {
  return (
    <section style={{ marginTop: 50 }}>
      <SectionText>{title}</SectionText>
      <Card style={cardStyle}>{children}</Card>
    </section>
  );
};
